import { Theme } from '@mui/material/styles'

/**
 * Centralized typography styles
 * Use these instead of repeating text styles across components
 */

/**
 * Page header style - large bold title (24px)
 */
export const headerStyle = (theme: Theme) => ({
  fontWeight: 'bold',
  fontSize: 24,
  color: theme.palette.text.primary,
})

/**
 * Section header style (20px)
 */
export const sectionHeaderStyle = (theme: Theme) => ({
  fontSize: 20,
  color: theme.palette.text.primary,
})

/**
 * Detail header style - medium bold (22px)
 */
export const detailHeaderStyle = (theme: Theme) => ({
  fontWeight: 'bold',
  fontSize: 22,
  color: theme.palette.text.primary,
})

/**
 * Detail name style - extra bold (22px, 800 weight)
 */
export const detailNameStyle = (theme: Theme) => ({
  fontWeight: 800,
  fontSize: 22,
  color: theme.palette.text.primary,
})

/**
 * Detail text style - bold (16px)
 */
export const detailTextStyle = (theme: Theme) => ({
  fontWeight: 'bold',
  fontSize: 16,
  color: theme.palette.text.primary,
})

/**
 * Organization/entity text style - bold (16px)
 */
export const entityTextStyle = (theme: Theme) => ({
  fontWeight: 'bold',
  fontSize: 16,
  color: theme.palette.text.primary,
})

/**
 * Standard text style - regular body text (18px)
 */
export const textStyle = (theme: Theme) => ({
  width: '100%',
  color: theme.palette.text.primary,
  padding: theme.spacing(1),
  fontSize: 18,
})

/**
 * Dialog title style
 */
export const dialogTitleStyle = () => ({
  fontWeight: 'bold',
  textAlign: 'center' as const,
})

/**
 * Overlay/watermark text style
 */
export const overlayTextStyle = (_theme: Theme) => ({
  position: 'absolute' as const,
  top: '-700px',
  left: '50%',
  transform: 'translateX(-50%)',
  color: 'rgba(255, 0, 0, 0.8)',
  fontSize: 22,
  fontStyle: 'italic',
  fontWeight: 'bolder',
  zIndex: 1001,
  textAlign: 'center' as const,
  width: '80%',
  pointerEvents: 'none' as const,
})
